<p-dialog
  [visible]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="calendar-consent-dialog"
  header="Calendar Invite Permission"
>
  <div class="consent-body">
    <div class="consent-icon">
      <i class="pi pi-calendar" aria-hidden="true"></i>
    </div>

    <p class="consent-intro">
      This application can send <strong>calendar invites</strong> to your Microsoft Outlook calendar
      on your behalf via <strong>Microsoft Graph</strong> when you are invited to a punch round.
    </p>

    <p class="consent-details">
      By accepting, you allow the system to add calendar events directly to your Outlook calendar.
      You can revoke this permission at any time from your <em>User Preferences</em>.
    </p>

    <p class="consent-decline-note">
      If you decline, you will still receive email notifications about punch rounds,
      but no calendar events will be created.
    </p>
  </div>

  <ng-template pTemplate="footer">
    <div class="consent-footer">
      <p-button
        label="No, Thanks"
        severity="secondary"
        [outlined]="true"
        (onClick)="decline()"
        styleClass="consent-btn"
      ></p-button>
      <p-button
        label="Yes, I Consent"
        severity="success"
        (onClick)="accept()"
        styleClass="consent-btn"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>

